import { render, staticRenderFns } from "./ReservationProcessDataTransitionForm.vue?vue&type=template&id=20f6218c&scoped=true&"
import script from "./ReservationProcessDataTransitionForm.vue?vue&type=script&lang=js&"
export * from "./ReservationProcessDataTransitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6218c",
  null
  
)

export default component.exports